import { cva } from 'class-variance-authority'

const filledBlue = 'font-sans-semi-bold bg-primary text-white border-primary'
const outlineBlue =
  'font-sans-semi-bold bg-transparent text-primary border-primary disabled:text-white aria-disabled:text-white'

export const buttonVariants = cva(
  [
    'inline-flex items-center justify-center border-2',
    'disabled:bg-gray-medium disabled:border-gray-medium',
    'aria-disabled:bg-gray-medium aria-disabled:border-gray-medium',
  ],
  {
    variants: {
      variant: {
        primary: filledBlue,
        secondary: outlineBlue,
        filledWhite: 'bg-white text-black border-white',
        filledWhiteBlue: 'bg-white text-primary border-primary',
        outlineWhite: 'border-white bg-transparent text-white',
        tertiary: 'font-sans bg-white text-gray-medium border-gray-medium',
        green: 'font-sans-semi-bold bg-green text-white border-green',
        outlineBlack: 'text-black border-black bg-transparent',
        filledBlue,
        outlineBlue,
        filledBrandColor: filledBlue,
        outlineBrandColor: outlineBlue,
        filledCustomColor:
          'text-white bg-[var(--custom-color)] border-[var(--custom-color)]',
        outlineCustomColor:
          'text-[var(--custom-color)] bg-transparent border-[var(--custom-color)]',
      },
      size: {
        default: 'min-h-9 md:min-h-10.5 gap-2',
        sm: 'min-h-8.5 md:min-h-10 gap-2',
        icon: 'border-none size-[46px] md:size-[52px]',
      },
      textSize: {
        base: 'text-xs !leading-none',
        mobileLarge: 'text-sm md:text-xs !leading-none',
        large: 'text-sm',
      },
      padding: {
        base: 'px-2 py-1.5',
        large: 'p-[0.55em_0.7em_0.35em_0.7em] gap-2',
      },
      rounded: {
        full: 'rounded-full',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default',
      textSize: 'base',
      padding: 'base',
    },
  }
)
